import dayjs from 'dayjs';
import React from 'react';
import { camelCaseToSpace } from 'shared-utils';
import { useUserContext } from 'src/context/UserProvider';
interface Props {
	companyName: string;
	positionName: string;
	offeredCtc: string;
	offeredDesignation: string;
	accManagerRemarks: string;
	internshipCtc?: number;
	internshipDuration?: number;
	dateOfJoining?: Date;
	isInternShipPosition?: boolean;
	jobType?: string;
}
const OfferedPositionParameters = ({
	companyName,
	positionName,
	offeredCtc,
	offeredDesignation,
	accManagerRemarks,
	internshipCtc,
	internshipDuration,
	dateOfJoining,
	jobType,
	isInternShipPosition,
}: Props) => {
	const { isAccountManagerLoggedIn, isRecruiterLoggedIn } = useUserContext();
	return (
		<div>
			{!isAccountManagerLoggedIn && !isRecruiterLoggedIn && (
				<div>
					<p className="font-inter text-[18px] font-[500] leading-[28px] dark:text-[#E4E4EB]">
						{companyName} - {positionName} offer
					</p>
				</div>
			)}
			{/* Comemnts */}
			{accManagerRemarks ? (
				<div className="border dark:border-[#C7C9D933] bg-[#E5F0FF] dark:bg-[#18222D] mt-[14px] rounded-[8px] p-[10px]">
					<p className="dark:text-[#F2F2F5]">
						<span className="text-[#FF3B3B]">Comments: </span>
						{accManagerRemarks}
					</p>
				</div>
			) : null}

			<div className="mt-[16px]">
				{jobType ? (
					<p className="font-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Job Type: </span>
						{camelCaseToSpace(jobType)}
					</p>
				) : null}
				{Number(offeredCtc) ? (
					<p className="font-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Offered CTC: </span>
						{offeredCtc} {Number(offeredCtc) > 100 && String(offeredCtc).length > 3 ? '' : 'LPA'}
					</p>
				) : null}
				{offeredDesignation ? (
					<p className="ffont-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Offered Designation: </span>
						{offeredDesignation}
					</p>
				) : null}
				{internshipCtc ? (
					<p className="ffont-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Internship Salary: </span>
						{internshipCtc} K
					</p>
				) : null}
				{internshipDuration ? (
					<p className="ffont-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Internship Duration: </span>
						{internshipDuration} {internshipDuration > 1 ? `months` : `month`}
					</p>
				) : null}
				{dateOfJoining ? (
					<p className="ffont-inter text-[18px] font-[400] leading-[28px] dark:text-[#E4E4EB]">
						<span className="text-[16px]">Joining Date: </span>
						{dayjs(dateOfJoining).format('DD MMM, YYYY')}
					</p>
				) : null}
			</div>
		</div>
	);
};

export default OfferedPositionParameters;
